module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [(_vm.description !== null && _vm.latests !== null) ? _c('div', [(_vm.description.content == null) ? _c('spinner') : _vm._e(), (_vm.description.content != null) ? _c('div', [_c('div', {
    staticClass: "description",
    domProps: {
      "innerHTML": _vm._s(_vm.renderText(_vm.description.content.acf.content, _vm.description.content.acf.contentEn))
    }
  }), _c('div', {
    staticClass: "projectLinks"
  }, _vm._l((_vm.pages), function(page, index) {
    return _c('div', {
      staticClass: "projectLink",
      class: page.slug
    }, [_c('router-link', {
      attrs: {
        "to": _vm.toAboutPage(page.slug)
      }
    }, [_c('p', {
      staticClass: "subTitle"
    }, [_vm._v(_vm._s(_vm.renderText(page.subTitle.ja, page.subTitle.en)))]), _c('h2', {
      staticClass: "projectTitle"
    }, [_vm._v(_vm._s(_vm.renderText(page.title.ja, page.title.en)))])])])
  })), _c('h3', {
    staticClass: "contentTitle"
  }, [_vm._v(_vm._s(_vm.renderText('活動報告', 'ACTIVITY')))]), _vm._l((_vm.latests), function(posts) {
    return _c('div', [_vm._l((posts.content), function(post) {
      return _c('postLink', {
        staticClass: "postLink",
        attrs: {
          "post": post,
          "projectName": _vm.getProjectSlug(post)
        }
      })
    }), (posts.content == null) ? _c('spinner') : _vm._e()], true)
  }), _c('p', {
    staticClass: "readMore"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.toCategory
    }
  }, [_vm._v(_vm._s(_vm.renderText('活動報告一覧へ', 'VIEW MORE')))])])], true) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a1db8552!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/top/pageTemplate.vue
// module id = 108
// module chunks = 1